import { Route, Routes } from "react-router-dom";
import Maintenance from "src/pages/maintenance";
import MaintenanceGuard from "./MaintenanceGuard";
import ForgotPassword from "src/pages/auth/forgot-password";
import Login from "src/pages/auth/login";
import ResetPassword from "src/pages/auth/reset-password";
import TokenExpire from "src/pages/auth/token-expire";
import Dashboard from "src/pages/dashboard";
import Subscribe from "src/pages/subscribe";
import PlanPage from "src/pages/subscribe/plan";

const PublicRoutes = ({ loggedIn }: { loggedIn: boolean }) => (
  <div className="dashboard_wrapper">
    <Routes>
      <Route element={<MaintenanceGuard />}>
        <Route path="/*" element={loggedIn ? <Dashboard /> : <Login />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/signup" element={<Login />}></Route>
        <Route path="/forgot-password" element={<ForgotPassword />}></Route>
        <Route path="/set-password/:id" element={<ResetPassword />}></Route>
        <Route path="/token-expired" element={<TokenExpire />}></Route>
        <Route path="/subscribe" element={<Subscribe />}></Route>
        <Route path="/subscribe/plan" element={<PlanPage />}></Route>
        <Route path="/maintenance" element={<Maintenance />}></Route>
      </Route>
    </Routes>
  </div>
);

export default PublicRoutes;
